import { ACHIEVEMENT_CARD } from './achievementCard';
import { MORE_INFO_MODAL } from './moreInfoModal';

export const EARN = { ACHIEVEMENT_CARD, MORE_INFO_MODAL };
